import { useEffect, useState, useRef } from "react";

function useIntersectionObserver(callback, options) {
  const [isIntersecting, setIsIntersecting] = useState(
    false
  ); // Not used currently, but can be of use later
  const targetRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsIntersecting(entry.isIntersecting);
      if (entry.isIntersecting) callback();
    }, options);

    const { current: target } = targetRef;
    if (target) observer.observe(target);

    return () => {
      if (target) observer.unobserve(target);
    };
  }, [callback, options]);

  return targetRef; // Return the ref to be used in components
}

export default useIntersectionObserver;
